import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const UnreadMail16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M14.8893 3.60945C14.8867 3.60615 14.8841 3.60288 14.8815 3.59964C14.5859 3.2334 14.139 3 13.6389 3H2.36111C1.86287 3 1.41745 3.23163 1.12192 3.59547C1.11725 3.60112 1.11265 3.60686 1.10812 3.6127C0.884154 3.8961 0.75 4.25701 0.75 4.65V12.35C0.75 13.2613 1.47132 14 2.36111 14H13.6389C14.5287 14 15.25 13.2613 15.25 12.35V4.65C15.25 4.2555 15.1148 3.89334 14.8893 3.60945ZM3.15947 4.375L7.14551 7.51489C7.39048 7.70789 7.69091 7.81256 7.99998 7.81256C8.30904 7.81256 8.60944 7.70792 8.8544 7.51492L12.8405 4.375H3.15947ZM13.9074 5.26924L9.67303 8.60476C9.19336 8.98266 8.60516 9.18756 7.99998 9.18756C7.3948 9.18756 6.80659 8.98266 6.32693 8.60476L2.09259 5.26928V12.35C2.09259 12.5019 2.21281 12.625 2.36111 12.625H13.6389C13.7872 12.625 13.9074 12.5019 13.9074 12.35V5.26924Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
